

import '../../src/global.css';
import logo from "../assets/logo-greek-2.png";
import logo2Image from "../assets/ERA.png";
import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap';

function Header({ isServicePage, isAppDevelopmentPage, isSupportAndMaintenancePage, timeline, ease }) {
    const logoRef = useRef(null);
    const aboutLinkRef = useRef(null);
    const servicesLinkRef = useRef(null);
    const contactLinkRef = useRef(null);

    const webDevelopmentRef = useRef(null);
    const appDevelopmentRef = useRef(null);
    const softwareDevelopmentRef = useRef(null);
    const projectSupportRef = useRef(null);
    const supportAndMaintenanceRef = useRef(null);

    useEffect(() => {
        gsap.set([logoRef.current, aboutLinkRef.current, servicesLinkRef.current, contactLinkRef.current], { y: 0 });
        timeline.from(logoRef.current, {
            duration: 1,
            opacity: 1,
            y: 100,
            ease: ease
        });

        timeline.from([aboutLinkRef.current, servicesLinkRef.current, contactLinkRef.current], {
            duration: 2,
            opacity: 1,
            y: -100,
            stagger: {
                amount: 0.4
            },
            ease: ease,
        });

        gsap.from([webDevelopmentRef.current, appDevelopmentRef.current, softwareDevelopmentRef.current, projectSupportRef.current, supportAndMaintenanceRef.current], {
            duration: 0.5,
            opacity: 1,
            y: -20,
            stagger: 0.1,
            ease: ease,
        });

    }, [timeline, ease]);

    return (
        <header className={`header ${isServicePage || isAppDevelopmentPage || isSupportAndMaintenancePage ? 'bg-black' : 'bg-white'}`}>
            <div className="relative">
                <div className="header grid grid-cols-2 static top-0 left-0 right-0">
                    <div className="titleLogo" ref={logoRef}>
                        <Link to='/'>
                            <img src={isServicePage || isAppDevelopmentPage || isSupportAndMaintenancePage ? logo2Image : logo} alt="logo" className="h-20 w-32 p-1" />
                        </Link>
                    </div>
                    <div className={`navBar text-${isServicePage || isAppDevelopmentPage || isSupportAndMaintenancePage ? 'bg-black' : 'bg-white'} grid items-center justify-end mr-8`}>
                        <ul className="grid grid-cols-3 gap-28 font-inria text-lg">
                            <li>
                                <Link className={`aboutLink ${isServicePage || isAppDevelopmentPage || isSupportAndMaintenancePage ? 'underline-service' : 'underline'} ${isServicePage || isAppDevelopmentPage || isSupportAndMaintenancePage ? 'text-white' : 'text-black'}`} to='/about' ref={aboutLinkRef}> ABOUT</Link>
                            </li>
                            <li className="relative z-20">
                                <Link className={`servicesLink ${isServicePage || isAppDevelopmentPage || isSupportAndMaintenancePage ? 'underline-service' : 'underline'} ${isServicePage || isAppDevelopmentPage || isSupportAndMaintenancePage ? 'text-white' : 'text-black'}`} to='/services' ref={servicesLinkRef}> SERVICES</Link>
                                <ul className={`dropdown absolute top-full left-0 ${isServicePage || isAppDevelopmentPage || isSupportAndMaintenancePage ? 'bg-black text-white' : 'bg-white text-black'}  $shadow-lg mt-4 w-44`}  >
                                    <li ref={appDevelopmentRef}>
                                        <Link to='/services/app-development' className='block px-4 py-2 capitalize '>Application Development</Link>
                                    </li>
                                    <li ref={webDevelopmentRef}>
                                        <Link to='/services/web-development' className='block px-4 py-2 capitalize '>Web Development</Link>
                                    </li>
                                    <li ref={softwareDevelopmentRef}>
                                        <Link to='/services/software-development' className='block px-4 py-2 capitalize '>Software Development</Link>
                                    </li>
                                    <li ref={projectSupportRef}>
                                        <Link to='/services/project-support' className='block px-4 py-2 capitalize '>Project Support</Link>
                                    </li>
                                    <li ref={supportAndMaintenanceRef}>
                                        <Link to='/services/support-and-maintenance' className='block px-4 py-2 capitalize '>software support and Maintenance</Link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <Link className={`contactLink ${isServicePage || isAppDevelopmentPage || isSupportAndMaintenancePage ? 'underline-service' : 'underline'} ${isServicePage || isAppDevelopmentPage || isSupportAndMaintenancePage ? 'text-white' : 'text-black'}`} to='/contact' ref={contactLinkRef}> CONTACT</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;
